/**
 * HeroSocialMockup v6 · iter v28 r246
 *
 * User M1165: «carosello fammi una casa sola con la prima immagine,
 * togli il logo agenzia, inventa tutto. Prima/dopo vero (vuoto → arredato).
 * Open House ok. Quarto: restyling con video.»
 *
 * Griglia 2×2 sempre visibile, ognuna con un formato social diverso.
 * Tutti i mockup sono HTML puro per garantire coerenza e zero logo
 * di agenzie reali.
 *
 *   • Carosello       — 5 slide stessa casa (sala-after.jpg) con overlay
 *   • Prima → Dopo    — fade auto vuoto/arredato (staging-empty/furnished)
 *   • Open House      — post statico /landing/social-open-house.jpg
 *   • Restyling video — /landing/hero-social-restyling.mp4
 */
import React, { useEffect, useState } from "react";
import {
  InstagramLogo, FacebookLogo, WhatsappLogo, TiktokLogo,
  MapPin, ArrowRight,
} from "@phosphor-icons/react";

const SOCIAL = [
  { Icon: InstagramLogo, color: "#E1306C", label: "Instagram" },
  { Icon: FacebookLogo,  color: "#1877F2", label: "Facebook" },
  { Icon: WhatsappLogo,  color: "#25D366", label: "WhatsApp" },
  { Icon: TiktokLogo,    color: "#000000", label: "TikTok"   },
];

const BRAND = "#7C8B6E";
const HERO_IMG = "/landing/sala-after.jpg";

// 5 slide carosello, tutte sulla stessa casa (Bilocale Brera)
const CAROUSEL_SLIDES = [
  { kind: "cover" },
  { kind: "specs" },
  { kind: "highlights" },
  { kind: "address" },
  { kind: "cta" },
];

function CarouselSlideCover() {
  return (
    <>
      <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" loading="eager" />
      <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(to bottom, rgba(0,0,0,0.10) 0%, transparent 35%, rgba(0,0,0,0.55) 100%)" }} />
      <div className="absolute top-3 left-3 text-[7.5px] uppercase tracking-[0.30em] font-bold text-white/95" style={{ fontFamily: "'Space Grotesk', sans-serif", textShadow: "0 1px 6px rgba(0,0,0,0.45)" }}>
        Nuovo annuncio
      </div>
      <div
        className="absolute bottom-3 left-3 right-3 text-white"
        style={{ textShadow: "0 1px 6px rgba(0,0,0,0.45)" }}
      >
        <div className="text-[15px] sm:text-[18px] leading-[1.05] mb-1" style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: "italic", fontWeight: 400 }}>
          Bilocale luminoso<br />a Brera
        </div>
        <div className="text-[9px] tracking-[0.18em] uppercase font-semibold" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          € 480.000 · 72 m²
        </div>
      </div>
    </>
  );
}

function CarouselSlideSpecs() {
  return (
    <>
      <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" loading="eager" />
      <div className="absolute inset-0 bg-black/55" />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white px-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
        <div className="text-[7.5px] uppercase tracking-[0.30em] opacity-80 mb-3">In numeri</div>
        <div className="grid grid-cols-2 gap-3 sm:gap-5">
          <div className="text-center">
            <div className="text-[20px] sm:text-[24px] tabular-nums leading-none" style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: "italic", fontWeight: 400 }}>72</div>
            <div className="text-[7px] tracking-[0.24em] uppercase opacity-75 mt-1">m²</div>
          </div>
          <div className="text-center">
            <div className="text-[20px] sm:text-[24px] tabular-nums leading-none" style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: "italic", fontWeight: 400 }}>2</div>
            <div className="text-[7px] tracking-[0.24em] uppercase opacity-75 mt-1">Locali</div>
          </div>
          <div className="text-center">
            <div className="text-[20px] sm:text-[24px] tabular-nums leading-none" style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: "italic", fontWeight: 400 }}>1</div>
            <div className="text-[7px] tracking-[0.24em] uppercase opacity-75 mt-1">Bagno</div>
          </div>
          <div className="text-center">
            <div className="text-[20px] sm:text-[24px] tabular-nums leading-none" style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: "italic", fontWeight: 400 }}>3°</div>
            <div className="text-[7px] tracking-[0.24em] uppercase opacity-75 mt-1">Piano</div>
          </div>
        </div>
      </div>
    </>
  );
}

function CarouselSlideHighlights() {
  return (
    <>
      <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" loading="eager" />
      <div className="absolute inset-0 bg-black/60" />
      <div className="absolute inset-0 flex flex-col justify-center px-4 text-white" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
        <div className="text-[7.5px] uppercase tracking-[0.30em] opacity-80 mb-2">Highlights</div>
        <ul className="space-y-1.5 text-[10px] sm:text-[11.5px] leading-snug">
          <li className="flex items-center gap-1.5"><span className="w-1 h-1 rounded-full" style={{ background: BRAND }} /> Ristrutturato a nuovo</li>
          <li className="flex items-center gap-1.5"><span className="w-1 h-1 rounded-full" style={{ background: BRAND }} /> Parquet a spina ungherese</li>
          <li className="flex items-center gap-1.5"><span className="w-1 h-1 rounded-full" style={{ background: BRAND }} /> Doppia esposizione</li>
          <li className="flex items-center gap-1.5"><span className="w-1 h-1 rounded-full" style={{ background: BRAND }} /> Climatizzato · cantina</li>
        </ul>
      </div>
    </>
  );
}

function CarouselSlideAddress() {
  return (
    <>
      <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" loading="eager" />
      <div className="absolute inset-0 bg-black/55" />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white px-3 text-center" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
        <div className="text-[7.5px] uppercase tracking-[0.30em] opacity-80 mb-2">Posizione</div>
        <MapPin size={20} weight="fill" className="mb-2 opacity-90" style={{ color: "#E8E2D2" }} />
        <div className="text-[12px] sm:text-[14px] leading-tight" style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: "italic", fontWeight: 400 }}>
          Via Solferino 18<br />Milano · Brera
        </div>
        <div className="mt-2 text-[8px] tracking-[0.20em] uppercase opacity-75">
          A 2 minuti dal Brera District
        </div>
      </div>
    </>
  );
}

function CarouselSlideCTA() {
  return (
    <>
      <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover blur-[4px] scale-110" loading="eager" />
      <div className="absolute inset-0" style={{ background: `linear-gradient(135deg, ${BRAND}f5 0%, ${BRAND}d0 100%)` }} />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white px-3 text-center">
        <div className="text-[7.5px] uppercase tracking-[0.30em] opacity-90 mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          Vuoi visitarla?
        </div>
        <div className="text-[14px] sm:text-[18px] leading-tight mb-3" style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: "italic", fontWeight: 400 }}>
          Scrivimi su WhatsApp
        </div>
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white text-[10px] font-semibold" style={{ color: BRAND, fontFamily: "'Space Grotesk', sans-serif" }}>
          Prenota visita <ArrowRight size={10} weight="bold" />
        </span>
      </div>
    </>
  );
}

function CarouselTile() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % CAROUSEL_SLIDES.length), 2200);
    return () => clearInterval(t);
  }, []);
  const slide = CAROUSEL_SLIDES[idx];
  return (
    <>
      {slide.kind === "cover"      && <CarouselSlideCover />}
      {slide.kind === "specs"      && <CarouselSlideSpecs />}
      {slide.kind === "highlights" && <CarouselSlideHighlights />}
      {slide.kind === "address"    && <CarouselSlideAddress />}
      {slide.kind === "cta"        && <CarouselSlideCTA />}
      {/* Dots */}
      <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1 z-10">
        {CAROUSEL_SLIDES.map((_, i) => (
          <span
            key={i}
            className="block rounded-full transition-all"
            style={{
              width: i === idx ? 10 : 4,
              height: 4,
              background: i === idx ? "rgba(255,255,255,0.95)" : "rgba(255,255,255,0.55)",
            }}
          />
        ))}
      </div>
    </>
  );
}

/* Prima → Dopo: fade auto staging-empty ⇄ staging-furnished */
function PrimaDopoTile() {
  const [phase, setPhase] = useState(0); // 0 = empty, 1 = furnished
  useEffect(() => {
    const t = setInterval(() => setPhase((p) => 1 - p), 2400);
    return () => clearInterval(t);
  }, []);
  return (
    <>
      <img
        src="/landing/staging-empty.jpg"
        alt="Spazio vuoto"
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1200ms]"
        style={{ opacity: phase === 0 ? 1 : 0 }}
        loading="eager"
      />
      <img
        src="/landing/staging-furnished.jpg"
        alt="Spazio arredato"
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1200ms]"
        style={{ opacity: phase === 1 ? 1 : 0 }}
        loading="eager"
      />
      <div className="absolute top-3 left-3 z-10">
        <span
          className="inline-block px-2 py-0.5 text-[7.5px] uppercase tracking-[0.22em] font-bold rounded-sm"
          style={{
            background: phase === 0 ? "rgba(255,255,255,0.92)" : `${BRAND}f0`,
            color: phase === 0 ? "#1C1C1A" : "#FFFFFF",
            fontFamily: "'Space Grotesk', sans-serif",
            transition: "background 600ms, color 600ms",
          }}
        >
          {phase === 0 ? "Prima" : "Dopo"}
        </span>
      </div>
    </>
  );
}

function OpenHouseTile() {
  return (
    <img
      src="/landing/social-open-house.jpg"
      alt="Open House"
      className="absolute inset-0 w-full h-full object-cover"
      loading="eager"
    />
  );
}

/* iter v29 r050 — VendutaTile: foto + sticker rotato "VENDUTA" sopra,
   per il reel 04 dove l'utente vuole mostrare anche il "venduto" come
   contenuto social condivisibile.
*/
function VendutaTile() {
  return (
    <>
      <img
        src={HERO_IMG}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(28,28,26,0.18) 0%, rgba(28,28,26,0.55) 100%)" }} />
      {/* Sticker grande in centro */}
      <div
        className="absolute"
        style={{
          top: "50%", left: "50%",
          transform: "translate(-50%, -50%) rotate(-8deg)",
          padding: "6px 16px",
          background: "#C03A26",
          color: "#FAF8F4",
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: 16,
          fontWeight: 800,
          letterSpacing: "0.22em",
          boxShadow: "0 8px 22px -6px rgba(0,0,0,0.55)",
          border: "2px solid #FAF8F4",
        }}
      >
        VENDUTA
      </div>
      {/* Footer testo */}
      <div className="absolute bottom-2 left-3 right-3 text-white" style={{ textShadow: "0 1px 4px rgba(0,0,0,0.45)" }}>
        <div className="text-[10px] sm:text-[12px] leading-tight" style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: "italic", fontWeight: 400 }}>
          In 28 giorni.
        </div>
        <div className="text-[7.5px] tracking-[0.22em] uppercase font-semibold opacity-85" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          Brera · €480.000
        </div>
      </div>
    </>
  );
}

/* iter v29 r050 — StoryTile: Instagram Story 9:16 sintetica con
   progress bar, handle agente e badge "NUOVO ANNUNCIO".
*/
function StoryTile() {
  return (
    <>
      <img
        src="/landing/staging-furnished.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0) 30%, rgba(0,0,0,0) 65%, rgba(0,0,0,0.75) 100%)" }} />
      {/* Story progress bars */}
      <div className="absolute top-2 left-2 right-2 flex gap-1">
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex-1 h-[2px] rounded-full overflow-hidden" style={{ background: "rgba(255,255,255,0.3)" }}>
            <div className="h-full" style={{ width: i === 0 ? "100%" : i === 1 ? "55%" : "0%", background: "#FFFFFF" }} />
          </div>
        ))}
      </div>
      {/* Handle */}
      <div className="absolute top-4 left-2 flex items-center gap-1.5 text-white">
        <div className="w-4 h-4 rounded-full flex items-center justify-center" style={{ background: BRAND, border: "1px solid #FFFFFF", fontSize: 7, fontWeight: 800, fontFamily: "'Space Grotesk', sans-serif" }}>P</div>
        <span className="text-[7px] font-semibold" style={{ textShadow: "0 1px 4px rgba(0,0,0,0.4)" }}>casetua_milano</span>
      </div>
      {/* Badge inclinato */}
      <div
        className="absolute"
        style={{
          top: "38%", left: "50%",
          transform: "translateX(-50%) rotate(-6deg)",
          padding: "4px 10px",
          background: "#C8A66B",
          color: "#1C1C1A",
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: 8.5,
          fontWeight: 800,
          letterSpacing: "0.20em",
          borderRadius: 999,
          boxShadow: "0 4px 14px -4px rgba(0,0,0,0.45)",
        }}
      >
        NUOVO ANNUNCIO
      </div>
      {/* Bottom CTA */}
      <div className="absolute bottom-1.5 left-2 right-2">
        <div className="text-[9.5px] text-white font-semibold tracking-[0.18em] uppercase text-center py-1 rounded-full" style={{ background: "rgba(255,255,255,0.18)", border: "1px solid rgba(255,255,255,0.5)", fontFamily: "'Space Grotesk', sans-serif" }}>
          Scopri →
        </div>
      </div>
    </>
  );
}

function RestylingTile({ reelMode = false }) {
  // r051 — crossfade JS tra 2 frame (prima/dopo) ogni 1.4s con badge HTML
  // visibile e contenuto nei bounds del tile (mai tagliato).
  // Usato sia in reelMode che in landing per garantire badge visibile.
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setPhase((p) => 1 - p), 1400);
    return () => clearInterval(t);
  }, []);
  return (
    <>
      <img
        src="/landing/restyling-prima-clean.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        style={{ opacity: phase === 0 ? 1 : 0, transition: "opacity 600ms ease-in-out" }}
        loading="eager"
      />
      <img
        src="/landing/restyling-dopo-clean.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        style={{ opacity: phase === 1 ? 1 : 0, transition: "opacity 600ms ease-in-out" }}
        loading="eager"
      />
      <div className="absolute inset-x-0 top-0 h-10 pointer-events-none" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0) 100%)" }} />
      <div className="absolute top-2 left-2 z-10">
        <span
          className="inline-block px-2 py-0.5 text-[8px] uppercase tracking-[0.22em] font-bold rounded-sm"
          style={{
            background: phase === 0 ? "rgba(255,255,255,0.95)" : `${BRAND}f5`,
            color: phase === 0 ? "#1C1C1A" : "#FFFFFF",
            fontFamily: "'Space Grotesk', sans-serif",
            transition: "background 400ms, color 400ms",
            boxShadow: "0 2px 6px -2px rgba(0,0,0,0.4)",
          }}
        >
          {phase === 0 ? "Prima" : "Dopo"}
        </span>
      </div>
    </>
  );
}

const TILES = [
  { id: "carosello",  label: "Carosello",       render: (p) => <CarouselTile {...p} /> },
  { id: "prima_dopo", label: "Prima → Dopo",    render: (p) => <PrimaDopoTile {...p} /> },
  { id: "open_house", label: "Open House",      render: (p) => <OpenHouseTile {...p} /> },
  { id: "restyling",  label: "Restyling video", render: (p) => <RestylingTile {...p} /> },
];

// iter v29 r050 — Extra tile mostrati solo in reelMode (reel 04).
// L'utente vuole: "open house · venduto · storia · prima/dopo · restyling
// non in grande ma come nella landing".
const REEL_TILES = [
  { id: "open_house", label: "Open House",      render: (p) => <OpenHouseTile {...p} /> },
  { id: "venduta",    label: "Venduta",         render: (p) => <VendutaTile {...p} /> },
  { id: "story",      label: "Storia",          render: (p) => <StoryTile {...p} /> },
  { id: "prima_dopo", label: "Prima → Dopo",    render: (p) => <PrimaDopoTile {...p} /> },
  { id: "restyling",  label: "Restyling video", render: (p) => <RestylingTile {...p} /> },
  { id: "carosello",  label: "Carosello",       render: (p) => <CarouselTile {...p} /> },
];

function SocialTile({ t, reelMode }) {
  return (
    <div className="relative">
      <div
        className="relative aspect-square rounded-[12px] overflow-hidden bg-[#F7F4EE]"
        style={{
          boxShadow:
            "0 14px 32px -16px rgba(28,28,26,0.30), 0 4px 10px -2px rgba(28,28,26,0.08), inset 0 0 0 1px rgba(28,28,26,0.06)",
        }}
        data-testid={`social-mockup-${t.id}`}
      >
        {t.render({ reelMode })}
      </div>
      <div className="mt-1.5 text-center">
        <span className="text-[10px] uppercase tracking-[0.20em] font-semibold text-[#6B6A65]">
          {t.label}
        </span>
      </div>
    </div>
  );
}

export default function HeroSocialMockup({ reelMode = false } = {}) {
  // reelMode: griglia 2×3 con 6 tile (open house, venduta, storia,
  // prima/dopo, restyling, carosello). Landing: griglia 2×2 con 4 tile.
  const tiles = reelMode ? REEL_TILES : TILES;
  const gridCols = "grid-cols-2";
  return (
    <div className="w-full max-w-[560px] mx-auto" data-testid="hero-social-mockup">
      <div className={`grid ${gridCols} gap-3 sm:gap-4`}>
        {tiles.map((t) => (
          <SocialTile key={t.id} t={t} reelMode={reelMode} />
        ))}
      </div>

      {/* Social row — destinazioni */}
      <div className="mt-4 flex justify-center items-center gap-2">
        <span className="text-[10px] uppercase tracking-[0.20em] font-semibold text-[#6B6A65] mr-1">
          Pubblica su
        </span>
        {SOCIAL.map(({ Icon, color, label }) => (
          <span
            key={label}
            className="inline-flex items-center justify-center w-6 h-6 rounded-full"
            style={{ background: `${color}14`, color }}
            aria-label={label}
            title={label}
          >
            <Icon size={12} weight="fill" />
          </span>
        ))}
      </div>
    </div>
  );
}
